exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".info__wrapper{padding:5px 0 5px 60px;position:relative}.info__icon{position:absolute;left:0;top:0;width:44px}.info__status{font-size:20px;line-height:1;margin:0 0 10px;font-weight:700}.arrow-link{cursor:pointer}.arrow-link .link__img{margin-left:3px;width:14px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f67e05aa","scoped":false,"hasInlineConfig":true}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/dashboard/my-data/braster-allowed.vue
// module id = 867
// module chunks = 0